import React, { useState } from 'react';
import api from '../api';

export default function LoginPage({ onLogin }) {
  const [form, setForm] = useState({ email: '', password: '', name: '' });
  const [modus, setModus] = useState('login');
  const [fehler, setFehler] = useState('');
  const [laden, setLaden] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setFehler('');
    setLaden(true);
    try {
      const r = await api.post(`/auth/${modus}`, form);
      onLogin(r.data.token);
    } catch (e) {
      setFehler(e.response?.data?.error || 'Anmeldung fehlgeschlagen. Bitte prüfe E-Mail und Passwort.');
    } finally {
      setLaden(false);
    }
  }

  const inp = { width: '100%', padding: '12px', borderRadius: '10px', border: '1px solid #e2e8f0', fontSize: '15px', boxSizing: 'border-box', marginBottom: '12px' };
  const lbl = { display: 'block', fontSize: '13px', fontWeight: '600', marginBottom: '4px', color: '#374151' };

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg,#1e293b,#334155)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
      <div style={{ background: 'white', borderRadius: '20px', padding: '32px', width: '100%', maxWidth: '380px' }}>
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <div style={{ fontSize: '48px' }}>📦</div>
          <h1 style={{ margin: '8px 0 4px', fontSize: '22px' }}>Lager Organizer</h1>
        </div>
        {fehler && <div role="alert" style={{ background: '#fee2e2', color: '#dc2626', padding: '10px', borderRadius: '8px', marginBottom: '12px' }}>{fehler}</div>}
        <form onSubmit={submit} aria-label={modus === 'login' ? 'Anmeldeformular' : 'Registrierungsformular'}>
          {modus === 'register' && (
            <>
              <label style={lbl} htmlFor="login-name">Name</label>
              <input id="login-name" style={inp} placeholder="Dein Name" value={form.name} onChange={e => setForm({...form, name: e.target.value})} autoFocus />
            </>
          )}
          <label style={lbl} htmlFor="login-email">E-Mail</label>
          <input id="login-email" style={inp} type="email" placeholder="deine@email.de" value={form.email} onChange={e => setForm({...form, email: e.target.value})} required autoFocus={modus === 'login'} />
          <label style={lbl} htmlFor="login-password">Passwort</label>
          <input id="login-password" style={inp} type="password" placeholder="Passwort eingeben" value={form.password} onChange={e => setForm({...form, password: e.target.value})} required />
          <button type="submit" disabled={laden}
            style={{ width: '100%', padding: '14px', background: laden ? '#d97706' : '#f59e0b', color: 'white', border: 'none', borderRadius: '10px', fontSize: '15px', fontWeight: '700', cursor: laden ? 'wait' : 'pointer', opacity: laden ? 0.85 : 1, marginTop: '4px' }}>
            {laden ? '⏳ Bitte warten...' : (modus === 'login' ? '🔑 Anmelden' : '📝 Registrieren')}
          </button>
        </form>
        <button onClick={() => setModus(modus === 'login' ? 'register' : 'login')}
          style={{ width: '100%', marginTop: '10px', padding: '10px', background: 'none', border: 'none', color: '#6366f1', cursor: 'pointer' }}>
          {modus === 'login' ? 'Noch kein Konto? Registrieren' : 'Bereits registriert? Anmelden'}
        </button>
      </div>
    </div>
  );
}
